import { Button, Form, Input, Modal, Select, Spin, Typography } from "antd";
import React from "react";
import authAdminService from "../../../../apis/admin/authAdminService";
import notificationHandler from "../../../atoms/Notification";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import rolesAdmin from "../../../../apis/admin/rolesService";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../app/store";
import { getUserDatas } from "../kitchen/slice";

type Props = {};

const CreactAccount = (props: Props) => {
  const { Option } = Select;
  const { Title } = Typography;
  const navigate = useNavigate();
  const [listRoles, setListRoles] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );
  const [modal, contextHolder] = Modal.useModal();
  const { kitchens }: any = useSelector(
    (state: RootState) => state.kitChenList
  );
  const listOptionKitchens = kitchens.map((item: any) => {
    return {
      value: item.id,
      label: item.kitchenName,
    };
  });

  const selectedRoleIds = Form.useWatch("roleIds", form);
  const shouldShowKitchen = selectedRoleIds
    ? !selectedRoleIds.includes(1) &&
      selectedRoleIds.some((roleId: number) => [2, 3].includes(roleId))
    : false;

  const confirm = (values: any) => {
    modal.confirm({
      title: "Bạn có chắc chắn muốn thêm tài khoản?",
      icon: <ExclamationCircleOutlined />,
      okText: "Đồng ý",
      cancelText: "Hủy",
      okType: "danger",
      onOk: () => onFinish(values),
    });
  };

  React.useEffect(() => {
    dispatch(getUserDatas({ status: "", value: "" }));
    rolesAdmin
      .getRolesData()
      .then((res: any) => {
        setListRoles(res.data.data.payload);
      })
      .catch((err: any) => {
        notificationHandler("error", err.response.data.data.msg_content);
      });
  }, []);

  const onFinish = (values: any) => {
    authAdminService
      .register(values)
      .then(() => {
        notificationHandler("success", "Thêm mới tài khoản thành công!");
        navigate("/admin/listAccount");
        setLoading(false);
      })
      .catch((err) => {
        notificationHandler("error", err.response.data.data.msg_content);
        setLoading(false);
      });
  };
  const validateSpecialCharacters = (_: any, value: any) => {
    const specialCharsRegex = /[!"#$%&'()*+,\./:;<=>?@[\\\]^`{|}~]/;
    if (specialCharsRegex.test(value)) {
      return Promise.reject("Tên tài khoản không được chứa ký tự đặc biệt!");
    }
    return Promise.resolve();
  };
  return (
    <div className="p-[20px]">
      <Spin indicator={antIcon} spinning={loading} />
      <Title className="!text-[20px]">Thêm Tài khoản</Title>
      <Form
        initialValues={{ remember: true }}
        onFinish={confirm}
        layout={"vertical"}
        className="w-[300px]"
        form={form}
      >
        <Form.Item
          label="Tên tài khoản"
          name="username"
          normalize={(value, prevVal, prevVals) => value.trim()}
          rules={[
            { required: true, message: "Vui lòng nhập tên tài khoản !" },
            {
              validator: validateSpecialCharacters,
            },
          ]}
        >
          <Input placeholder="Nhập tên tài khoản" showCount maxLength={200} />
        </Form.Item>
        <Form.Item
          name={"roleIds"}
          label={"Danh sách quyền"}
          rules={[{ required: true, message: "Vui lòng chọn quyền!" }]}
        >
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Chọn quyền"
            optionLabelProp="label"
            allowClear
            filterOption={(input, option) => {
              return (
                // @ts-ignore
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {listRoles?.map((item: any, key: number) => (
              <Option
                key={item.id}
                value={item.id}
                label={item.roleName}
                className="flex items-center justify-center"
              >
                <span>{item.roleName}</span>
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Mật khẩu"
          name="password"
          rules={[{ required: true, message: "Vui lòng nhập mật khẩu !" }]}
        >
          <Input.Password
            placeholder="Mật khẩu"
            onBlur={(e) => (e.target.value = e.target.value.trim())}
            showCount
            maxLength={50}
          />
        </Form.Item>
        {shouldShowKitchen && (
          <Form.Item
            label="Bếp ăn"
            name="kitchenId"
            rules={[{ required: true, message: "Vui lòng chọn bếp ăn!" }]}
          >
            <Select
              style={{ width: "100%" }}
              placeholder={"Chọn bếp ăn"}
              options={listOptionKitchens}
            />
          </Form.Item>
        )}
        <Form.Item>
          <div className="flex">
            <Button
              htmlType="button"
              type="primary"
              className="mt-4 mr-4 border-[#808080] hover:border-[#808080] hover:text-[#808080] hover:bg-white bg-[#808080] text-white"
            >
              <Link to={"/admin/listAccount"} className="flex items-center">
                <ArrowLeftOutlined className="mr-2" /> Quay lại
              </Link>
            </Button>
            <Button
              htmlType="submit"
              type="primary"
              className="mt-4 text-white bg-[#1890ff] hover:bg-white hover:text-[#1890ff]"
              loading={loading}
            >
              <SaveOutlined /> Lưu
            </Button>
            <Button
              htmlType="reset"
              className="mt-4 text-[##ff4d4f] ml-4  bg-[#ff4d4f] text-white"
              danger
            >
              <ReloadOutlined /> Đặt lại
            </Button>
          </div>
          {contextHolder}
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreactAccount;
